import { render, staticRenderFns } from "./Crop2D.vue?vue&type=template&id=305c9c1c&scoped=true&"
import script from "./Crop2D.vue?vue&type=script&lang=ts&"
export * from "./Crop2D.vue?vue&type=script&lang=ts&"
import style0 from "@/src/components/styles/vtk-view.css?vue&type=style&index=0&id=305c9c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305c9c1c",
  null
  
)

export default component.exports